import { Injectable } from '@angular/core';
import { DzModalService } from '@blk/daisy/modules/modals';
import { PartnerAcknowledgement, PartnerPlatform } from '@ddt-web/shared-stores';
import { Observable } from 'rxjs';
import { first, mergeMap, take } from 'rxjs/operators';

import { PartnerAcknowledgementDialogComponent } from '../partner-portfolios/partner-acknowledgement-dialog/partner-acknowledgment-dialog.component';
import { PartnerAcknowledgementService } from './partner-acknowledgement.service';



@Injectable({
	providedIn: 'root'
})
export class PartnerAcknowledgementDeeplinkService {
	constructor(
		private partnerAcknowledgementService: PartnerAcknowledgementService,
		private dzModalService: DzModalService
	) { }

	public handleDeeplinkAcknowledgement(selectedPartner: PartnerPlatform, partnerAcknowledgement: PartnerAcknowledgement): Observable<PartnerAcknowledgement> {
		const configData = {
			showClose: false,
			style: {
				'background-color': 'white'
			},
			size: 'md',
			contentData: {
				selectedPartner,
				partnerAcknowledgement
			}
		};
		const dialogRef = this.dzModalService.open(PartnerAcknowledgementDialogComponent, configData);
		return dialogRef.afterClosed$.pipe(
			first(),
			mergeMap(() => this.partnerAcknowledgementService.retrievePartnerAcknowledgementInfo().pipe(take(1)))
		);
	}
}
